import SimulateCheckoutDialog from './SimulateCheckoutDialog';

export default SimulateCheckoutDialog;